"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLEXIBLE_STAKING_ACCOUNT_LEN = exports.FLEXIBLE_VAULT_LEN = exports.LOCKUP_STAKING_ACCOUNT_LEN = exports.WITHDRAW_POSITION_LEN = exports.LOCKUP_VAULT_LEN = exports.SOLCAT_FLEXIBLE_STAKING_ACCOUNT_LEN = exports.SOLCAT_LOCKUP_STAKING_ACCOUNT_LEN = exports.SOLCAT_WITHDRAW_POSITION_LEN = exports.SOLCAT_LOCKUP_VAULT_LEN = exports.I64_SIZE = exports.U64_SIZE = exports.U32_SIZE = exports.U16_SIZE = exports.U8_SIZE = exports.PUBKEY_SIZE = exports.DISCRIMINATOR_SIZE = exports.SCALE_FACTOR = exports.SOLCAT_DECIMALS = exports.STAKING_PROGRAM_ID_V2 = exports.SOLCAT_STAKING_PROGRAM_ID = exports.PROGRAM_ID_V2 = exports.PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = __importDefault(require("bn.js"));
exports.PROGRAM_ID = new web3_js_1.PublicKey("9aU1jUaLwNm2nNcHBJYK5xmRtnKRmzCwgkEAtLS7PErA");
exports.PROGRAM_ID_V2 = new web3_js_1.PublicKey("CpX1do1a4fB36B5sETTUW1kMLYTBnuSUPNosQM8LVQRQ");
exports.SOLCAT_STAKING_PROGRAM_ID = exports.PROGRAM_ID;
exports.STAKING_PROGRAM_ID_V2 = exports.PROGRAM_ID_V2;
exports.SOLCAT_DECIMALS = 6;
exports.SCALE_FACTOR = new bn_js_1.default(10).pow(new bn_js_1.default(18));
exports.DISCRIMINATOR_SIZE = 8;
exports.PUBKEY_SIZE = 32;
exports.U8_SIZE = 1;
exports.U16_SIZE = 2;
exports.U32_SIZE = 4;
exports.U64_SIZE = 8;
exports.I64_SIZE = 8;
exports.SOLCAT_LOCKUP_VAULT_LEN = 8 + 1 + 2 * 2 + 8 + 8 * 3; // 45
exports.SOLCAT_WITHDRAW_POSITION_LEN = 8 + 1 + 4 + 32 + 8 * 2 + 1; // 62
exports.SOLCAT_LOCKUP_STAKING_ACCOUNT_LEN = 8 + 1 + 32 + 4 + 32 + 2 + 8 * 2 + 1; // 96
exports.SOLCAT_FLEXIBLE_STAKING_ACCOUNT_LEN = 8 + 1 + 32 + 8 * 2 + 16; // 73
exports.LOCKUP_VAULT_LEN = 8 + 1 + 32 + 2 * 2 + 8 * 4; // 77
exports.WITHDRAW_POSITION_LEN = 8 + 1 + 32 + 4 + 32 + 8 * 2 + 1; // 94
exports.LOCKUP_STAKING_ACCOUNT_LEN = 8 + 1 + 32 + 4 + 32 * 2 + 2 + 8 * 2 + 1; // 128
exports.FLEXIBLE_VAULT_LEN = 8 + 1 + 32 + 8 * 5 + 16; // 97
exports.FLEXIBLE_STAKING_ACCOUNT_LEN = 8 + 1 + 32 * 2 + 8 * 2 + 16; // 105
